import streakProtection from './streakProtection';
import interfaceCopy from './interface';
import reviewLevelUp from './reviewLevelUp';
import writingExam from './writingExam';
import dashboard from './dashboard';
import accountActivity from './accountActivity';
import learningNavigation from './learningNavigation';
import authUx from './authUx';
import tournamentUx from './tournamentUx';
import theme from './theme';
import notesUnified from './notesUnified';
import quickPractice from './quickPractice';
import practiceUi from './practiceUi';
import vocabulary from './vocabulary';

const en = {
  streakProtection: streakProtection.en,
  vocabulary: vocabulary.en,
  reviewLevelUp: reviewLevelUp.en,
  writingExam: writingExam.en,
  practiceUi: practiceUi.en,
  notesUnified: notesUnified.en,
  quickPractice: quickPractice.en,
  interface: interfaceCopy.en,
  dashboard: dashboard.en,
  accountActivity: accountActivity.en,
  learningNavigation: learningNavigation.en,
  authUx: authUx.en,
  tournamentUx: tournamentUx.en,
  theme: theme.en,
  app: {
    title: {
      aria: 'English PT Club',
      language: 'English',
      pt: 'PT',
      club: 'club',
      subtitle: 'REP & SPEAK',
    },
  },
  common: {
    close: 'Close',
    ok: 'OK',
    cancel: 'Cancel',
    save: 'Save',
    next: 'Next',
    continue: 'Continue',
    startTraining: 'Start Training',
    confirmTitle: 'Are you sure?',
  },
  playerLevelUp: {
    title: 'Level Up!',
    message: 'Your training raised your level from {previousLevel} to {level}.',
  },
  noteCompletion: {
    title: 'Note complete!',
    message: 'You completed every card in “{noteTitle}”. Well done!',
    untitled: 'Untitled note',
  },
  recordAchievement: {
    title: 'Record unlocked!',
    message: 'You unlocked the {record} record. A new card is now yours!',
  },
  pwa: {
    installButton: 'Install App',
    installTitle: 'Install English PT Club',
    iosSafariInstructions: 'Tap the Share button in Safari, then choose Add to Home Screen. You can confirm or edit the app name before adding it.',
    iosBrowserInstructions: 'Open this page in Safari. Tap Share, then choose Add to Home Screen.',
    browserInstructions: 'Open your browser menu and choose Install app or Add to Home screen. The install option appears when your browser confirms the app is ready.',
  },
  auth: {
    headings: {
      login: 'Sign in',
      signup: 'Create account',
      forgot: 'Reset password',
      reset: 'Choose new password',
      verify: 'Verify email',
    },
    labels: {
      email: 'Email',
      nickname: 'Nickname',
      password: 'Password',
      confirmPassword: 'Confirm password',
    },
    buttons: {
      working: 'Working...',
      agreeAndCreate: 'Agree and create account',
      backToForm: 'Back',
    },
    links: {
      signIn: 'Sign in',
      createAccount: 'Create account',
      forgotPassword: 'Forgot your password?',
    },
    messages: {
      emailVerified: 'Email verified. You can sign in now.',
      verifyFailed: 'Email verification failed.',
      accountCreated: 'Account created. Check your email for the verification link.',
      resetSent: 'If that email exists, a reset link has been sent.',
      resetComplete: 'Password reset complete. You can sign in now.',
      failed: 'Authentication failed. Please try again.',
    },
    validation: {
      passwordMin: 'Password must be at least 8 characters.',
      passwordLetterNumber: 'Password must include at least one letter and one number.',
      passwordMismatch: 'Passwords do not match.',
      agreementRequired: 'Please agree to the service terms.',
    },
    agreement: {
      title: 'Service Agreement',
      intro: 'Before creating your English PT Club account, please review these terms.',
      terms: [
        'We store account and learning data such as email, nickname, study records, points, repeat counts, and practice time to provide the service.',
        'Your learning records are used to personalize progress, scheduling, achievements, and review features.',
        'We may process necessary data to operate the service, fix errors, maintain security, and improve features.',
        'Passwords are stored securely, and your email may be used for verification and password reset messages.',
      ],
      improvement: 'Your data can be used for improving this program.',
      checkbox: 'I have reviewed and agree to the service terms and data use described above.',
    },
  },
  levelUp: {
    guidance: 'Upgrade the sentence. Keep the key expressions, but feel free to change the tense, turn it into a question or a negative sentence, or even change the subject or object. Try adding Before and After lines to complete a short dialogue.',
    title: 'Level Up!',
    successMessage: 'Card reached Level {level}. Keep building your own sentence.',
  },
  autoRepeat: {
    title: 'Auto Repeat?',
    confirm: 'Auto Repeat',
    limitMessage: 'Only {count} {repeatWord} will be added before this card reaches the point limit. +{score} pt.',
    fillMessage: 'Fill {count} remaining {repeatWord} for this card. +{score} pt.',
    repeatSingular: 'repeat',
    repeatPlural: 'repeats',
  },
  gradeThreeMilestone: {
    title: 'Grade 3 Reached',
    message: 'You reached Grade 3 with only {score} pt. Your memory is developing quickly.',
    iconAlt: 'Trainer celebrating Grade 3',
  },
  practicePhases: {
    memoryTrial: {
      title: 'Fluency Test',
      label: 'Fluency Test',
      speedLabel: 'Fluency Test',
      start: 'How quickly you can speak matters too. Cards in today’s test: {count}.',
      startImageAlt: 'Fluency Test starts',
      completeTitle: 'Fluency Test Complete',
      completeToCore: 'Well done! Cards passed: {success}. Cards failed: {fail}.',
      completeWithoutCore: 'Well done! Cards passed: {success}. Cards failed: {fail}.',
      endImageAlt: 'Fluency Test complete',
    },
    coreTraining: {
      title: 'Core Training',
    },
    reading: {
      title: 'Reading Practice',
      start: 'This is reading practice. Read and repeat.',
      startImageAlt: 'Beep introduces reading practice',
    },
    npcEncounter: {
      title: 'NPC Encounter',
    },
  },
  browserTts: {
    play: 'Play this sentence',
    stop: 'Stop sentence playback',
    membership: 'Membership sentence listening',
    unavailableTitle: 'Browser Speech Unavailable',
    unavailableMessage: 'This browser could not play the sentence. Please check your device speech settings or try another browser.',
  },
  readingSpeech: {
    frontBonus: 'Front +{score} pt',
    noFlipBonus: 'Not flipping +{score} pt',
    midSentenceBonus: 'Long +{score} pt',
    longSentenceBonus: 'Long +{score} pt',
  },
  membership: {
    labels: {
      membership: 'Membership',
      trial: 'Trial Membership',
      user: 'User',
    },
    dailyLimit: {
      title: "Today's Workouts Complete",
      message: "You've used today's 2 workout starts. Give your memory time to settle, and we'll be ready for you again tomorrow. Membership offers unlimited daily workouts.",
    },
    practiceUnavailable: {
      title: 'Workout Unavailable',
      message: 'We could not open this workout right now. Please check your connection and try again.',
    },
    tts: {
      title: 'Membership Listening',
      message: 'TTS creation and listening are Membership features. Membership also includes unlimited daily workouts. Thank you for growing with English PT Club.',
    },
    account: {
      membership: 'Thank you sincerely for being a Membership member. Your support keeps English PT Club growing. Enjoy unlimited workouts and TTS listening.',
      trial: 'Your 7-day Membership trial is active until {date}. Explore unlimited workouts and TTS listening while every gate is open.',
      user: 'A stronger training journey is waiting. Membership unlocks unlimited workouts and TTS listening. Membership enrollment is coming soon.',
    },
  },
  practicePlayer: {
    modes: {
      focus: 'Focus',
      drill: 'Drill',
      review: 'Review',
    },
    modeDescriptions: {
      focus: 'Prioritize ready cards with fewer repeats. Answers play 4 times.',
      drill: 'Randomly train any unfinished card. Answers play 4 times.',
      review: 'Randomly revisit completed cards. Answers play 4 times.',
    },
    settings: {
      testRepeatName: 'Test & Repeat',
      testRepeatDescription: 'Answer questions, then read aloud repeatedly. Flashcard and speaking practice.',
      listeningName: 'Listen & Repeat',
      listeningDescription: 'Listen to questions and answers, then repeat aloud. Listening, shadowing, and speaking practice.',
    },
    empty: {
      title: 'No Cards To Play',
      focus: 'No cards are ready for Focus right now.',
      drill: 'No unfinished cards match this card filter.',
      review: 'No completed cards match this card filter.',
    },
    page: {
      title: 'Practice Player',
      preparing: 'Preparing your playlist...',
      ready: 'Ready to play',
      playing: 'Playing',
      pausing: 'Pausing after this step',
      paused: 'Paused',
      skipped: 'Skipped a card whose listening audio was unavailable.',
      question: 'Question',
      answer: 'Answer',
      article: 'Article',
      end: 'End Practice',
      endTitle: 'End Practice?',
      endMessage: 'Completed listening repeats will be saved and this session will finish.',
      home: 'Back to Home',
      retry: 'Try Again',
      preparationTimedOut: 'Audio preparation took too long. Please try again.',
      noPlayable: 'None of these cards has playable listening audio.',
      serviceUnavailable: 'The listening service is temporarily unavailable. Please try again after the server restarts.',
      qUnavailable: 'Question voice was unavailable. Continuing with the answer.',
      playbackInterrupted: 'Audio was interrupted. Tap Play to retry this card.',
      ring: 'Starting card',
      blank: 'Your turn',
      reading: 'Reading',
      saving: 'Saving practice...',
      completeTitle: 'Training Set Complete!',
      completeMessage: 'Your Practice Player playlist is complete.',
      timeTitle: '30 Minutes Complete!',
      timeMessage: 'You finished the current card and completed 30 minutes of training.',
      currentCover: 'Current drill cover',
      stepProgress: 'Player step progress',
      seek: 'Seek reading audio',
      playControl: 'Play Practice Player',
      pauseControl: 'Pause Practice Player',
      previousCard: 'Previous card',
      nextCard: 'Next card',
      trainerAlt: 'Cheerful trainer',
    },
  },
  presetLibrary: {
    unavailableTitle: 'Preset Library',
    unavailableMessage: 'Preset library for this language is not ready yet. Please ask AAStudio through Instagram.',
  },
  reviews: {
    title: 'Ratings & comments',
    ratings: 'ratings',
    averageRating: 'Average rating',
    rateStar: 'Rate {rating} stars',
    leaveYours: 'Leave a rating',
    editYours: 'Edit your rating',
    notice: 'Please keep your comment respectful. Inappropriate comments may be removed.',
    commentPlaceholder: 'Optional one-line comment',
    commentLabel: 'Review comment',
    importFirst: 'Import this item to leave a rating. Reviews are anonymous in public.',
    loading: 'Loading reviews...',
    empty: 'No reviews yet.',
    loadFailed: 'Reviews could not be loaded.',
    saveFailed: 'Your review could not be saved.',
    saving: 'Saving...',
    save: 'Save review',
    previous: 'Previous',
    next: 'Next',
  },
  market: {
    eyebrow: 'Community library',
    title: 'Market',
    back: 'Back to Library',
    topImported: 'Most imported',
    topRated: 'Top rated',
    myUploads: 'My uploads',
    board: 'Community board',
    search: 'Search titles and descriptions',
    searchButton: 'Search',
    sortLabel: 'Sort Market listings',
    sort: { latest: 'Newest', rating: 'Rating', imports: 'Imports' },
    loading: 'Loading Market...',
    empty: 'No community notes match this search yet.',
    publish: 'Publish to Market',
    publishAction: 'Publish',
    backToMarket: 'Back to Market',
    publishing: 'Publishing...',
    publishHelp: 'Publish an independent snapshot of this drill. Later edits to your private note will not change the Market copy.',
    communityEdition: 'Community edition',
    by: 'by',
    cards: 'cards',
    level: 'Level',
    import: 'Import note',
    imported: 'Imported',
    report: 'Report',
    edit: 'Edit note',
    editAction: 'Edit',
    ownerActions: 'Market note actions',
    moreActions: 'More Market note actions',
    publicationOn: 'Publication ON',
    publicationOff: 'Publication OFF',
    delete: 'Delete',
    deleteConfirmTitle: 'Delete this Market note?',
    deleteConfirmMessage: '“{title}” will be permanently removed from the Market. Notes already imported by other learners will not be affected.',
    withdraw: 'Withdraw',
    restore: 'Restore',
    examples: 'Inside this note',
    examplesHelp: 'Browse five cards at a time.',
    previewPagination: 'Note preview pages',
    reportTitle: 'Report this listing',
    reportDetails: 'Optional details (one line)',
    submitReport: 'Send report',
    reportSent: 'Thank you. Your report was sent to the administrators.',
    reportCategories: {
      inappropriate: 'Inappropriate content',
      legal: 'Legal or copyright issue',
      misleading: 'Misleading information',
      harmful: 'Harmful content',
      other: 'Other',
    },
    form: {
      title: 'Title',
      cover: 'Cover image',
      addImage: 'Add image',
      changeImage: 'Change image',
      removeImage: 'Remove image',
      selectImage: 'Select cover image',
      coverPreview: 'Cover preview',
      imageFormats: 'JPEG, PNG, WebP · Max 5 MB',
      description: 'Description',
      difficulty: 'Difficulty',
      questionLanguage: 'Question language',
      learningLanguage: 'Learning language',
      cardsText: 'Cards',
      cardsTextHelp: 'Edit the extracted card text. Separate cards with ---. Use @Q:/@A: for cards and @R: for reading.',
    },
    status: { active: 'Published', withdrawn: 'Withdrawn', removed: 'Removed' },
    errors: {
      load: 'The Market could not be loaded.',
      detail: 'This Market listing could not be loaded.',
      action: 'The Market action could not be completed.',
      notFound: 'This listing is unavailable.',
      publish: 'This note could not be published.',
      imageType: 'Only JPEG, PNG, and WebP files are accepted.',
      imageSize: 'The image must be 5 MB or smaller.',
    },
  },
  noteComposer: {
    locales: {
      'en-US': 'English (United States)',
      'ko-KR': 'Korean',
      'ja-JP': 'Japanese',
      'zh-CN': 'Chinese (Mainland)',
      'es-ES': 'Spanish (Spain)',
    },
    types: {
      simple: 'Simple Card',
      normal: 'Card',
      article: 'Article',
      dialog: 'Dialog',
    },
    page: {
      eyebrow: 'Note editor',
      addNoteTitle: 'Add New Note',
      createHelp: 'Name your note and add the cards you want to learn.',
      addCardsTitle: 'Add Flashcards',
      contentHeading: 'Note content',
      noteName: 'Name',
      noteNamePlaceholder: 'Enter a name for this note',
      practiceState: 'Include in workouts',
      enabled: 'Enabled',
      disabled: 'Disabled',
      enabledDescription: 'This note will be included in practice.',
      disabledDescription: 'Draft and organize it without adding it to practice yet.',
      addOneCard: 'Add one card',
      copyFormats: 'Copy formats',
      copied: 'Copied',
      manual: 'Manual',
      copyGuidance: 'Paste the formats into your memo app and make your own note.',
      contentLabel: 'Content',
      contentPlaceholder: 'Paste your flashcards here, or use Add one card.',
      review: 'Review cards',
      back: 'Go back',
      loading: 'Loading note...',
    },
    builder: {
      kicker: 'Card builder',
      title: 'Add One Card',
      typeLegend: 'Card type',
      formatLabel: 'Format text',
      previewLabel: 'Preview and syntax check',
      checking: 'Checking the format...',
      addCard: 'Add to note',
    },
    preview: {
      showQuestion: 'Show question',
      showAnswer: 'Show answer',
    },
    confirm: {
      kicker: 'Final check',
      title: 'Review New Cards',
      count: '{count} cards will be saved.',
      save: 'Save cards',
      saving: 'Saving...',
      questionLocale: 'Question language',
      learningLocale: 'Learning language',
      detected: 'Suggested from your cards. You can change it before saving.',
      defaulted: 'Could not detect reliably. Please check before saving.',
    },
    errors: {
      empty: 'Enter at least one flashcard.',
      parseFailed: 'The card could not be read. {details}',
      oneCardOnly: 'This builder accepts one card at a time. It found {count}.',
      simpleTooLong: 'This answer is too long for a Simple Card. Shorten it or choose Card.',
      typeMismatch: 'This text is formatted as {actual}, not {expected}. Select the matching type or adjust the tags.',
      noteNameRequired: 'Enter a name for the note.',
      cardLimit: 'A note can contain up to {max} cards. It currently has {current}, and this would add {added}.',
      loadNote: 'The note could not be loaded. {details}',
      copyFailed: 'The formats could not be copied. Check clipboard permission and try again.',
      reviewFailed: 'The existing cards could not be checked. {details}',
      saveFailed: 'The cards could not be saved. {details}',
      syntax: {
        empty: 'Enter at least one flashcard.',
        incompleteCard: 'A basic card needs exactly two lines: the question, then the answer.',
        qaRequired: 'A tagged card needs both @Q: and @A:.',
        readingTitle: 'A reading card needs a title after @R:.',
        readingPractice: 'A reading card needs practice content under @Story:, @A:, or @B:.',
        continuation: 'Text after @R: must follow @Story:, @Scene:, @A:, or @B:.',
        tagNeedsText: 'One of the tags is empty. Add text after the tag or on its following line.',
        legacyTag: 'This uses an old tag. Use @Q:, @A:, and @R: formats instead.',
        unsupportedTag: 'The text contains an unsupported tag. Check the copied formats.',
        taggedLine: 'Tagged cards must use supported @ tags. Check the copied formats.',
        mixedCard: 'Do not mix @R: reading content with @Q: or @A: in the same card.',
        generic: 'The format has a syntax error. Check separators and required tags.',
      },
    },
  },
  notes: {
    importComplete: '"{title}" was imported and is ready for practice.',
    enable: 'Enable',
    disable: 'Disable',
    enabled: 'Enabled',
    disabled: 'Disabled',
    savingState: 'Saving...',
    stateUpdateFailedTitle: 'State Not Saved',
    stateUpdateFailedMessage: 'The drill state could not be updated. Please try again.',
    disabledPracticeTitle: 'Drill Is Disabled',
    disabledPracticeMessage: 'Enable this drill on its map page before starting practice.',
  },
  library: {
    title: 'Library', subtitle: 'Find your next chapter of learning.', back: 'Back to main page',
    discover: 'Discover', all: 'Browse all', officialTab: 'Official', market: 'Market', navigation: 'Library sections',
    myUploads: 'My uploads', publish: 'Publish a note', filters: 'Library filters',
    searchFilters: 'Search & filters', openSearchFilters: 'Open search and filters', closeSearchFilters: 'Close search and filters', activeFilters: '{count} active',
    audience: 'Question language', learningLanguage: 'Learning language', allLanguages: 'All languages',
    search: 'Search titles, topics or creators', searchButton: 'Search',
    difficulty: 'Difficulty', allLevels: 'All levels', topic: 'Topic', allTopics: 'All topics',
    source: 'Source', allSources: 'All sources', official: 'Official collection', community: 'Community',
    officialLibrary: 'Official library', unclassified: 'Uncategorized',
    groupBy: 'Group by', unknownLanguage: 'Unspecified language', unknownDifficulty: 'Unspecified difficulty',
    pageGroupCount: '{count} notes in this group on this page',
    sort: 'Sort by', defaultSort: 'Recommended order', latest: 'Newest first', ratingSort: 'Highest rated', importSort: 'Most imported',
    officialShelf: 'A good place to begin', officialIntro: 'Handpicked notes from the official collection.',
    marketShelf: 'From the community', marketIntro: 'Discover a different perspective, shared by other learners.',
    favorites: 'Favorites', favoritesIntro: 'Notes you saved for later.',
    viewAll: 'View all', exploreAll: 'Explore the whole library',
    openGroup: 'Open {title} group', openFavoritesGroup: 'Open Favorites group', viewGroup: 'View list', groupItemCount: '{count} notes',
    selectedGroup: 'Group: {group}', clearGroup: 'Clear group filter',
    openItem: 'Open {title}', imported: 'Imported', recommended: 'Recommended', clickedNote: 'Clicked note', cardCount: '{count} cards', level: 'Level {level}',
    results: 'Library results', resultCount: '{count} notes',
    managementHint: 'Your published and withdrawn notes, across all question languages.',
    limitedResults: 'There are more than 500 pages of results. Narrow your filters to find more notes.',
    empty: 'No notes match these filters yet. Try another language or clear your filters.',
    clearFilters: 'Clear filters', loading: 'Loading library…', loadError: 'Could not load the library.', retry: 'Try again',
    pagination: 'Library pages', previous: 'Previous', next: 'Next', pageStatus: '{page} / {pageCount}',
    presetPreviewTitle: 'Inside this preset', presetPreviewHelp: 'Browse five cards at a time.', presetPreviewEmpty: 'No cards to preview.', previewPagination: 'Preset preview pages', readingCard: 'Reading',
    languages: { ko: 'Korean', en: 'English', ja: 'Japanese', zh: 'Chinese', es: 'Spanish' },
    difficulties: { 1: 'Beginner', 2: 'Elementary', 3: 'Intermediate', 4: 'Upper-intermediate', 5: 'Advanced' },
  },
  notification: {
    eyebrow: 'Notice',
    defaultTitle: 'New notice',
    dontShowAgain: "Don't show again",
    closeLabel: 'Close notification',
  },
};

export default en;
